import { createRouter, createWebHashHistory } from 'vue-router';

const router = createRouter({
    history: createWebHashHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/',
            component: () => import('@/pages/Layout.vue'),
            redirect: '/novelty-search',
            children: [
                {
                    path: '/home',
                    name: 'home',
                    redirect: '/novelty-search',
                },
                {
                    path: '/novelty-search',
                    component: () => import('@/pages/novelty-search/NoveltySearchRootLayout.vue'),
                    children: [
                        {
                            path: '',
                            name: 'NoveltySearchLanding',
                            component: () => import('@/pages/novelty-search/LandingPage.vue'),
                        },
                        {
                            path: 'invention-points',
                            component: () => import('@/pages/novelty-search/components/NoveltySearchShellLayout.vue'),
                            children: [
                                {
                                    path: '',
                                    name: 'NoveltySearchInventionPoints',
                                    component: () => import('@/pages/novelty-search/InventionPoints.vue'),
                                }
                            ],
                        },
                        {
                            path: 'invention-points-pn',
                            component: () => import('@/pages/novelty-search/components/NoveltySearchShellLayout.vue'),
                            children: [
                                {
                                    path: '',
                                    name: 'NoveltySearchInventionPointsPn',
                                    component: () => import('@/pages/novelty-search/InventionPointsPn.vue'),
                                }
                            ],
                        },
                        {
                            path: 'feature-decomposition',
                            component: () => import('@/pages/novelty-search/components/NoveltySearchShellLayout.vue'),
                            children: [
                                {
                                    path: '',
                                    name: 'NoveltySearchFeatureDecomposition',
                                    component: () => import('@/pages/novelty-search/FeatureDecomposition.vue'),
                                }
                            ],
                        },
                        {
                            path: 'search-strategy',
                            component: () => import('@/pages/novelty-search/components/NoveltySearchShellLayout.vue'),
                            children: [
                                {
                                    path: '',
                                    name: 'NoveltySearchSearchStrategy',
                                    component: () => import('@/pages/novelty-search/SearchStrategy.vue'),
                                }
                            ],
                        },
                        {
                            path: 'search-results',
                            component: () => import('@/pages/novelty-search/components/NoveltySearchShellLayout.vue'),
                            children: [
                                {
                                    path: '',
                                    name: 'NoveltySearchSearchResults',
                                    component: () => import('@/pages/novelty-search/SearchResults.vue'),
                                }
                            ],
                        },
                        {
                            path: 'feature-comparison',
                            component: () => import('@/pages/novelty-search/components/NoveltySearchShellLayout.vue'),
                            children: [
                                {
                                    path: '',
                                    name: 'NoveltySearchFeatureComparison',
                                    component: () => import('@/pages/novelty-search/FeatureComparison.vue'),
                                }
                            ],
                        },
                        {
                            path: 'search-report',
                            component: () => import('@/pages/novelty-search/components/NoveltySearchShellLayout.vue'),
                            children: [
                                {
                                    path: '',
                                    name: 'NoveltySearchSearchReport',
                                    component: () => import('@/pages/novelty-search/SearchReport.vue'),
                                }
                            ],
                        }
                    ],
                }
            ],
        }
    ],
});

export default router;
